import React, { createContext, useContext, useLayoutEffect, useState } from 'react';

const PortalHeaderSetContext = createContext(null);
const PortalHeaderLeadingContext = createContext(null);

export const PortalHeaderProvider = ({ children }) => {
  const [leading, setLeading] = useState(null);
  return (
    <PortalHeaderSetContext.Provider value={setLeading}>
      <PortalHeaderLeadingContext.Provider value={leading}>
        {children}
      </PortalHeaderLeadingContext.Provider>
    </PortalHeaderSetContext.Provider>
  );
};

export const usePortalHeaderLeading = () => useContext(PortalHeaderLeadingContext);

/** Renders page back + title in the shared portal header row. */
export const PortalPageHeader = ({ title, onBack, showBack = Boolean(onBack) }) => {
  const setLeading = useContext(PortalHeaderSetContext);

  useLayoutEffect(() => {
    if (!setLeading) return undefined;
    setLeading({ title, onBack, showBack });
    return () => setLeading(null);
  }, [setLeading, title, onBack, showBack]);

  return null;
};
